function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { useContext } from 'react';
import get from 'lodash/get';
import { useTheme } from '@material-ui/core/styles';
import TenantThemeContext from '@signal/core/tenantTheme/Context';
import { paletteTypeSelector } from '@signal/theme/selectors';
import { Image } from './styles';
var DEFAULT_LOGO_HEIGHT = 80;
var DEFAULT_LOGO_WIDTH = 195;
export function Brand(_ref) {
  var _ref$height = _ref.height,
      height = _ref$height === void 0 ? DEFAULT_LOGO_HEIGHT : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? DEFAULT_LOGO_WIDTH : _ref$width,
      rest = _objectWithoutProperties(_ref, ["height", "width"]);

  var theme = useTheme();
  var paletteType = paletteTypeSelector(theme);
  var isDarkMode = paletteType === 'dark';
  var filename = isDarkMode ? 'PC-1c-reversed-horizontal' : 'PC-fc-horizontal';
  var tenantTheme = useContext(TenantThemeContext);
  var tenantLogo = get(tenantTheme, 'response.tenantLogo');
  var src = tenantLogo || "https://purecars-signal.imgix.net/app/".concat(filename, ".svg");
  return /*#__PURE__*/React.createElement(Image, Object.assign({
    alt: "Brand logo",
    src: src,
    height: height,
    width: width
  }, rest));
}
export default Brand;